/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CampaignModel from 'cio/models/campaign';
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

interface MessageSettingsCardArgs {
  campaign: CampaignModel;
  subscriptionCenterEnabled: boolean;
  subscriptionTopicsLength: boolean;
  page: 'review' | 'overview';
}

export default class MessageSettingsCard extends Component<MessageSettingsCardArgs> {
  @computed('args.campaign.{subscriptionTopic,sendToUnsubscribed}')
  get sendingToEveryone() {
    return this.args.campaign.sendToUnsubscribed === true;
  }

  @computed('args.campaign.{subscriptionTopic,sendToUnsubscribed}')
  get sendingToSubscribed() {
    return isEmpty(this.args.campaign.subscriptionTopic) && this.args.campaign.sendToUnsubscribed === false;
  }

  get disabledBannerType() {
    if (this.args.campaign.isApiTriggered) {
      return 'broadcast';
    }

    return null;
  }
}
